/**
 * Created by Ning Jiang on 11/22/2016.
 */

///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomWiggle.d.ts"/>
///<reference path="../../node_modules/@nolimitcity/slot-game/lib/gsap/src/CustomBounce.d.ts"/>
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DeadwoodGameModuleConfig} from "./DeadwoodGameModuleConfig";
import {DeadwoodWinFieldController} from "./winpresentation/initial/DeadwoodWinFieldController";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {APIBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {DeadwoodGameAssets} from "./DeadwoodGameAssets";
import {AssetQualityLevel} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";

require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");


export class Deadwood extends SlotGame {
    private skinner:Skinner;


    constructor() {
        super(DeadwoodGameModuleConfig.instance);
        const validSkins:string[] = [
            "us-nonfree" //gameClientConfiguration.replaceWordFree
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSkinInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (Deadwood.api.gameClientConfiguration.isSet){
           this.setSkinName();
        }
        else {
            Deadwood.api.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED,()=>{
                this.setSkinName();
            })
        }


    }

    private setSkinName():void{
        if (Deadwood.api.gameClientConfiguration.replaceWordFree){
            this.skinner.skinId = "us-nonfree";
        }
        if(this.skinner.skinId==="us-nonfree"){
            DeadwoodGameAssets.RESOURCES_GROUPS.main.forEach((ele)=>{
                if(ele.name==="main"){
                    ele.autoLoad=[AssetQualityLevel.HIGH];
                }
            })
        }
    }
    public init(): Promise<NolimitPlugin> {
        return super.init().then((plugin: NolimitPlugin) => {

            SlotGame.api.betHandler.addBetDataInjectCallback((data:APIBetEventData)=>this.injectExternalFreeBetCallback(data));

            this.handleSkinInit();
            return plugin;
        });
    }

    private injectExternalFreeBetCallback(betData:APIBetEventData) {
        if (betData.type === APIBetType.FREE_BET){
            (<any>betData).replayAndFeatureBuy = true; //Sort of a hack, this parameter is checked in balance.js. If true, it will skip balance - bet check. And allow "normal" bets to be done without checking that you can afford to make the bet.
        }
        return betData;
    }

    protected createWinFieldController(): WinFieldController {
        return new DeadwoodWinFieldController();
    }


    public async getReady(): Promise<NolimitPlugin> {
        const value = await super.getReady();
        await this.handleSkinGetReady();
        return value;
    }
    private async handleSkinGetReady() : Promise<any> {
        if (this.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            replaceMap.set("freespin/plus1_FS", "plus1_FS.png");
           return  await this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M2",
                    "M5",
                    "L1",
                    "L2",
                    "M4",
                    "L3"
                ],
                [
                    "L3",
                    "M1",
                    "M5",
                    "L2",
                    "M4",
                    "L4"
                ],
                [
                    "L1",
                    "M3",
                    "M2",
                    "L3",
                    "M3",
                    "M4"
                ],
                [
                    "L3",
                    "L4",
                    "L5",
                    "L1",
                    "M1",
                    "M3"
                ],
                [
                    "L1",
                    "L4",
                    "M4",
                    "M5",
                    "L2",
                    "M4"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "L1",
                    "L2",
                    "M4"
                ],
                [
                    "M1",
                    "M5",
                    "L2",
                    "M4"
                ],
                [
                    "M3",
                    "M2",
                    "L3",
                    "M3"
                ],
                [
                    "L4",
                    "L5",
                    "L1",
                    "M1"
                ],
                [
                    "X",
                    "M4",
                    "M5",
                    "L2"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "freespinMultiplierBefore": 1,
            "freespinMultiplierAfter": 1,
            "overlayWilds": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsBeforeSpin": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "L4",
                    "L3",
                    "L1"
                ],
                [
                    "L2",
                    "M3",
                    "M4"
                ],
                [
                    "M3",
                    "L4",
                    "L3"
                ],
                [
                    "M2",
                    "L4",
                    "M1"
                ],
                [
                    "M4",
                    "L4",
                    "L3"
                ]
            ],
            "bonusPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "multiplierOnReel": [
                0,
                0,
                0,
                0,
                0
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "fsSuperModeActive": false,
            "bonusTriggeredThisSpin": false,
            "playerFSSelection": -1,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 71
                },
                {
                    "name": "FREESPIN_BOUNTY",
                    "type": "FREESPIN",
                    "price": 750
                }
            ],
            "wasFeatureBuy": false,
            "featureBet": false,
            "numberOfSpinsFreespin": [
                0,
                0
            ]
        };
    }


    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#isGreece", "g"), (Deadwood.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });
    }
}
